import N8nFormBox from './FormBox.vue';

export default N8nFormBox;
